/**
 * Turn a redirect-state `from` location into a safe, same-origin app path.
 * Defaults to /dashboard. Rejects protocol-relative/backslash/non-"/" paths
 * and public auth routes (which would loop back to the login screen). (#1079)
 */
const AUTH_ROUTES = new Set([
  '/login',
  '/set-password',
  '/forgot-password',
  '/reset-password',
]);

const FALLBACK = '/dashboard';

export function safeRedirectPath(
  from: { pathname?: string; search?: string; hash?: string } | null | undefined,
): string {
  // Coerce any non-string pathname (e.g. a tampered sessionStorage value like
  // {"pathname":5}) to the fallback rather than throwing on .startsWith (#1124).
  const pathname = typeof from?.pathname === 'string' ? from.pathname : '';
  // Must be a same-origin app path: single leading slash, not "//" or "/\".
  if (!pathname.startsWith('/') || pathname.startsWith('//') || pathname.startsWith('/\\')) {
    return FALLBACK;
  }
  if (AUTH_ROUTES.has(pathname)) {
    return FALLBACK;
  }
  return `${pathname}${from?.search ?? ''}${from?.hash ?? ''}`;
}

/** sessionStorage key carrying the attempted route across the SSO full-page round-trip (#1124). */
export const SSO_RETURN_TO_KEY = 'sso_return_to';
